//auth
export const LOGIN = 'LOGIN';
export const GET_PROFILE = 'GET_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const UPDATE_SETTING = 'UPDATE_SETTING';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
// Master data
export const GET_MASTER_DATA = 'GET_MASTER_DATA';

//job
export const GET_JOBS = 'GET_JOBS';
export const GET_JOBS_BOARD = 'GET_JOBS_BOARD';
export const GET_JOBS_TIMELINE = 'GET_JOBS_TIMELINE';
export const GET_JOBS_LIST_MORE = 'GET_JOBS_LIST_MORE';
export const GET_JOB = 'GET_JOB';
export const GET_JOBS_SELECTION = 'GET_JOBS_SELECTION';
export const CREATE_JOB = 'CREATE_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const UPDATE_JOB_ALL = 'UPDATE_JOB_ALL';
export const GET_FILES = 'GET_FILES';

export const GET_FILE = 'GET_FILE';
export const UPDATE_FILE = 'UPDATE_FILE';
export const CREATE_FILES = 'CREATE_FILES';
export const DELETE_FILES = 'DELETE_FILES';
export const GET_ORGANIZATION = 'GET_ORGANIZATION';
export const GENERATE_SIGN_DOCUMENT = 'GENERATE_SIGN_DOCUMENT';

// Note
export const GET_NOTES = 'GET_NOTES';
export const CREATE_NOTE = 'CREATE_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
// Job type
export const GET_JOB_TYPES = 'GET_JOB_TYPES';
export const GET_JOB_TYPES_LIST = 'GET_JOB_TYPES_LIST';
export const CREATE_JOB_TYPES = 'CREATE_JOB_TYPES';
export const EDIT_JOB_TYPES = 'EDIT_JOB_TYPES';
export const GET_JOB_TYPE = 'GET_JOB_TYPE';

// Tag
export const GET_TAGS = 'GET_TAGS';

// Locations
export const GET_LOCATIONS = 'GET_LOCATIONS';

// Account
export const GET_SELECT_ACCOUNTS = 'GET_SELECT_ACCOUNTS';
export const GET_SELECT_SALEPERSONS = 'GET_SELECT_SALEPERSONS';
export const GET_ACCOUNTS_SELECTION = 'GET_ACCOUNTS_SELECTION';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';

// Task
export const GET_TASK_SELECTION = 'GET_TASK_SELECTION';
export const GET_TASK = 'GET_TASK';
export const GET_TASK_BOARD = 'GET_TASK_BOARD';
export const UPDATE_TASK = 'UPDATE_TASK';
export const CREATE_TASK = 'CREATE_TASK';
export const CREATE_FRANCHISE_TASK = 'CREATE_FRANCHISE_TASK';
export const GET_TASK_LIST = 'GET_TASK_LIST';
export const GET_FRANCHISE_TASK = 'GET_FRANCHISE_TASK';
export const UPDATE_FRANCHISE_TASK = 'UPDATE_FRANCHISE_TASK';
export const GET_FRANCHISE_TASK_LIST = 'GET_FRANCHISE_TASK_LIST';
export const GET_TASK_CUSTOMER_LIST = 'GET_TASK_CUSTOMER_LIST';
export const GET_TASK_FILE = 'GET_TASK_FILE';
//time-clocks
export const GET_TIME_CLOCKS = 'GET_TIME_CLOCKS';
export const GET_TIME_CLOCKS_SELECTION = 'GET_TIME_CLOCKS_SELECTION';
export const GET_TIME_CLOCK = 'GET_TIME_CLOCK';
export const CHECKIN_TIME_CLOCK = 'CHECKIN_TIME_CLOCK';
export const UPDATE_TIME_CLOCK = 'UPDATE_TIME_CLOCK';

//schedule
export const GET_SCHEDULE_EVENTS = 'GET_SCHEDULE_EVENTS';
export const GET_SCHEDULE_DAY_EVENTS = 'GET_SCHEDULE_DAY_EVENTS';
export const ADD_SCHEDULE_EVENT = 'ADD_SCHEDULE_EVENT';
export const UPDATE_SCHEDULE_EVENT = 'UPDATE_SCHEDULE_EVENT';

// Quickbook
export const GET_QUICKBOOK = 'GET_QUICKBOOK';
export const GET_QUICKBOOK_CUSTOMER = 'GET_QUICKBOOK_CUSTOMER';
export const GET_QUICKBOOK_ITEMS = 'GET_QUICKBOOK_ITEMS';
export const UPDATE_QUICKBOOK = 'UPDATE_QUICKBOOK';

//Estimate
export const GET_PRICE_COMPONENTS = 'GET_PRICE_COMPONENTS';
export const GET_PRICE_COMPONENT = 'GET_PRICE_COMPONENT';
export const CREATE_PRICE_COMPONENT = 'CREATE_PRICE_COMPONENT';
export const EDIT_PRICE_COMPONENT = 'EDIT_PRICE_COMPONENT';

export const GET_ESTIMATE_LIST = 'GET_ESTIMATE_LIST';
export const CREATE_ESTIMATE = 'CREATE_ESTIMATE';
export const GET_ESTIMATE = 'GET_ESTIMATE';
export const UPDATE_ESTIMATE = 'UPDATE_ESTIMATE';

export const GET_ESTIMATE_ITEMS = 'GET_ESTIMATE_ITEMS';

// Estimate Template
export const CREATE_ESTIMATE_TEMPLATE = 'CREATE_ESTIMATE_TEMPLATE';
export const GET_ESTIMATE_TEMPLATES = 'GET_ESTIMATE_TEMPLATES';
export const GET_ESTIMATE_TEMPLATE = 'GET_ESTIMATE_TEMPLATE';
export const UPLOAD_ESTIMATE_TEMPLATE_FILE = 'UPLOAD_ESTIMATE_TEMPLATE_FILE';
export const UPDATE_ESTIMATE_TEMPLATE = 'UPDATE_ESTIMATE_TEMPLATE';
//Price

export const CREATE_PRICE = 'CREATE_PRICE';
export const GET_PRICES = 'GET_PRICES';
export const GET_PRICE = 'GET_PRICE';
export const GET_ALL_PRICE = 'GET_ALL_PRICE';
export const EDIT_PRICE = 'EDIT_PRICE';

//Price item

export const CREATE_PRICE_ITEM = 'CREATE_PRICE_ITEM';
export const GET_PRICES_ITEM = 'GET_PRICES_ITEM';
export const GET_PRICE_ITEM = 'GET_PRICE_ITEM';
export const EDIT_PRICE_ITEM = 'EDIT_PRICE_ITEM';

//Equipment
export const CREATE_EQUIPMENT = 'CREATE_EQUIPMENT';
export const GET_EQUIPMENT = 'GET_EQUIPMENT';
export const GET_EQUIPMENTS = 'GET_EQUIPMENTS';
export const EDIT_EQUIPMENT = 'EDIT_EQUIPMENT';

//COGS
export const CREATE_COGS = 'CREATE_COGS';
export const GET_COGS = 'GET_COGS';
export const GET_COGS_LIST = 'GET_COGS_LIST';
export const EDIT_COGS = 'EDIT_COGS';

//Job status
export const CREATE_JOB_STATUS = 'CREATE_JOB_STATUS';
export const GET_JOB_STATUS = 'GET_JOB_STATUS';
export const GET_JOB_STATUSES = 'GET_JOB_STATUSES';
export const EDIT_JOB_STATUS = 'EDIT_JOB_STATUS';

//CRM status
export const CREATE_CRM_STATUS = 'CREATE_CRM_STATUS';
export const GET_CRM_STATUS = 'GET_CRM_STATUS';
export const GET_CRM_STATUSES = 'GET_CRM_STATUSES';
export const EDIT_CRM_STATUS = 'EDIT_CRM_STATUS';

//Area scope
export const CREATE_AREA_SCOPE = 'CREATE_AREA_SCOPE';
export const GET_AREA_SCOPES = 'GET_AREA_SCOPES';
export const GET_AREA_SCOPE = 'GET_AREA_SCOPE';
export const EDIT_AREA_SCOPE = 'EDIT_AREA_SCOPE';

//Customer
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const GET_CUSTOMER = 'GET_CUSTOMER';
export const GET_CUSTOMER_CONTACT = 'GET_CUSTOMER_CONTACT';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const GET_CUSTOMER_FILES = 'GET_CUSTOMER_FILES';
export const GET_CUSTOMER_FILE = 'GET_CUSTOMER_FILE';
export const GET_COMMON_SEARCH = 'GET_COMMON_SEARCH';
export const GET_SELECTION_CUSTOMER = 'GET_SELECTION_CUSTOMER';
export const CREATE_CUSTOMER_FILES = 'CREATE_CUSTOMER_FILES';
export const SEND_MAIL = 'SEND_MAIL';

// GOOGLE
export const GET_GOOGLE_SEARCH = 'GET_GOOGLE_SEARCH';
export const GET_GOOGLE_DETAIL = 'GET_GOOGLE_DETAIL';
// Template
export const GET_TEMPLATE = 'GET_TEMPLATE';
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const SHOW_TEMPLATE = 'SHOW_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';

// Folder
export const GET_FOLDERS = 'GET_FOLDERS';
export const GET_FOLDER = 'GET_FOLDER';
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';

//Contact
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const GET_ACTIVITY_CONTACT = 'GET_ACTIVITY_CONTACT';
export const GET_ACTIVITY_CONTACT_ORGANIZATION = 'GET_ACTIVITY_CONTACT_ORGANIZATION';

//Activity
export const GET_ACTIVITY = 'GET_ACTIVITY';
export const EDIT_CONTACT = 'EDIT_CONTACT';
export const GET_CONTACTS = 'GET_CONTACTS';

//CRM
export const GET_CRM_BOARD = 'GET_CRM_BOARD';

//FOLDER
export const GET_FILE_FROM_FOLDER = 'GET_FILE_FROM_FOLDER';

// NOTIFICATION
export const GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
export const UPDATE_NOTIFICATION_LIST = 'UPDATE_NOTIFICATION_LIST';
//Company
export const GET_SELECTION_COMPANY = 'GET_SELECTION_COMPANY';
// Invoice
export const GET_INVOICES = 'GET_INVOICES';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const GET_INVOICE = 'GET_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const DELETE_INVOICE = 'DELETE_INVOICE';
// Report
export const GET_FINANCIAL = 'GET_FINANCIAL';
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_ACTIVITY_REPORT = 'GET_ACTIVITY_REPORT';
export const GET_FRANCHISE_MKT_REPORT = 'GET_FRANCHISE_MKT_REPORT';
export const GET_LEAD_REPORT = 'GET_LEAD_REPORT';
export const GET_STAFF_SALE_REPORT = 'GET_STAFF_SALE_REPORT';
export const GET_PROJECT_REPORT = 'GET_PROJECT_REPORT';
export const GET_SALE_REPORT = 'GET_SALE_REPORT';
export const GET_CLOSING_RATE_REPORT = 'GET_CLOSING_RATE_REPORT';
export const GET_REFERRAL_SOURCE_REPORT = 'GET_REFERRAL_SOURCE_REPORT';
export const GET_TIME_CLOCK_REPORT = 'GET_TIME_CLOCK_REPORT';

// FRANCHISE
export const CREATE_FRANCHISE = 'CREATE_FRANCHISE';
export const GET_FRANCHISE = 'GET_FRANCHISE';
export const GET_FRANCHISE_DETAIL = 'GET_FRANCHISE_DETAIL';
export const UPDATE_FRANCHISE = 'UPDATE_FRANCHISE';
export const DETLETE_FRANCHISE = 'DETLETE_FRANCHISE';

// LOCATION COMPANY

export const LOCATION_COMPANY_LIST = 'LOCATION_COMPANY_LIST';
export const CREATE_LOCATION_COMPANY = 'CREATE_LOCATION_COMPANY';
export const GET_LOCATION_COMPANY_DETAIL = 'GET_LOCATION_COMPANY_DETAIL';
export const UPDATE_LOCATION_COMPANY = 'UPDATE_LOCATION_COMPANY';
export const DETLETE_LOCATION_COMPANY = 'DETLETE_LOCATION_COMPANY';

// ROLES
export const GET_ROLES = 'GET_ROLES';
export const GET_ROLE = 'GET_ROLE';
export const CREATE_ROLE = 'CREATE_ROLE';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const DELETE_ROLES = 'DELETE_ROLES';
export const GET_ROLE_SELECT = 'GET_ROLE_SELECT';

export const CREATE_MATERIAL_TYPE = 'CREATE_MATERIAL_TYPE';

// Campaign
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const EDIT_CAMPAIGN = 'EDIT_CAMPAIGN';

// Ring Central
export const GET_RING_CENTRAL = 'GET_RING_CENTRAL';
export const UPDATE_RING_CENTRAL = 'UPDATE_RING_CENTRAL';
